import { render, staticRenderFns } from "./TableAnnidata.vue?vue&type=template&id=77feb4f8&scoped=true"
import script from "./TableAnnidata.vue?vue&type=script&lang=js"
export * from "./TableAnnidata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77feb4f8",
  null
  
)

export default component.exports